module.exports = __webpack_public_path__ + "static/media/mshtml_32541.2ac8c330.ico";